import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaTotalFormaPagamento } from '@/features/relatorio/page/venda/total-forma-pagamento/RelatorioVendaTotalFormaPagamento';

export const Route = createFileRoute('/a/relatorio/venda/total-forma-pagamento')({
    component: RelatorioVendaTotalFormaPagamento,
});
